import { graphql } from "react-relay";
import { AvatarRow } from "@components/avatar";

export const fragments = {
  org: graphql`
    fragment TailoredDefragSummaryAttendees_org on Org {
      id
    }
  `,
  personList: graphql`
    fragment TailoredDefragSummaryAttendees_personList on PersonList {
      list {
        __typename
        id
        emails
        primaryEmail
        isYou
        userId
        isUser
        profile {
          givenName
          familyName
          externalImageUrl
        }
      }
    }
  `,
};
